const ls = {
    get(key) {
        let data = localStorage.getItem(key);

        if (data === null || data === undefined) return undefined;
        try {
            return JSON.parse(data);
        } catch (e) {
            return data; // fallback to raw string
        }
    },

    set(key, data) {
        try {
            const dataStr = JSON.stringify(data);
            localStorage.setItem(key, dataStr);
        } catch (e) {
            localStorage.setItem(key, String(data));
        }
    }
};

export default ls;
